/**
 * iView Admin Pro 业务配置
 * */

import { Message, Notice } from 'view-design'

const env = process.env.NODE_ENV

const serverList = {
  develop_server: 'https://dd.atlasai.tv',
  product_server: 'https://api.atlasai.tv',
  local_server: 'https://bw.huangyuqiang.cn'
}

const Setting = {
  /**
     * 基础配置
     * */
  // 网页标题的后缀
  titleSuffix: 'tv.SOGA',
  // 路由模式，可选值为 history 或 hash
  routerMode: 'history',
  // 应用的基路径
  routerBase: '/',
  // 页面切换时，是否显示模拟的进度条
  showProgressBar: true,
  // 服务器配置
  serverList: serverList,
  // 接口请求地址
  apiBaseURL: env === 'development' ? serverList.local_server : serverList.product_server,
  // 接口请求超时时间，单位：秒
  apiTimeout: 20,

  // 接口请求返回错误时，弹窗的持续时间，单位：秒
  modalDuration: 3,
  // 接口请求返回错误时，弹窗的类型，可选值为 Message 或 Notice
  errorModalType: 'Notice',
  // 错误提示弹窗标题
  errorModalTitle: 'Alert',
  // 错误提示弹窗标题
  errorDescriptions: {},
  // 错误显示
  showError: (message, code) => {},

  // Cookies 默认保存时间，单位：天
  cookiesExpires: 30,
  /**
    * 多语言配置
    * */
  i18n: {
    // 默认语言
    default: 'zh-TW',
    // 是否根据用户电脑配置自动设置语言（仅第一次有效）
    auto: true
  },
  /**
     * 多页 Tabs
     * */
  page: {
    // 默认打开的页签
    opened: []
  },
  languages: {
    'zh-TW': '繁體中文',
    'zh-CN': '简体中文',
    en: 'En'
  },

  yuan: 'NT$',
  stockLow: 1000,
  order_status: {
    0: '',
    1: '',
    2: '',
    3: '',
    4: '',
    5: '',
    10: '',
    98: '',
    99: ''
  },
  order_list: {
    err_status: 0, // 没有创建支付交易
    wait_buyer_pay: 1, // 等待买家付款
    wait_seller_send_goods: 2, // 买家已付款
    wait_buyer_confirm_goods: 3, // 卖家已发货
    trade_buyer_signed: 4, // 买家已签收
    trade_evaluated: 5, // 已收货，已评价
    trade_complete: 10, // 交易完成
    pay_fail: 98,
    trade_closed: 99 // 交易关闭
  },
  convertDiscount (val) {
    // 折扣
    return Math.ceil(val * 100) / 10;
  }
}

Setting.showError = (message, code) => {
  let showMsg = message;
  if (code) {
    showMsg = '[' + code + ']' + message;
  }
  // 显示提示，可配置使用 iView 的 $Message 还是 $Notice 组件来显示
  if (Setting.errorModalType === 'Message') {
    Message.error({
      content: showMsg,
      duration: Setting.modalDuration
    })
  } else if (Setting.errorModalType === 'Notice') {
    Notice.error({
      title: Setting.errorModalTitle,
      desc: showMsg,
      duration: Setting.modalDuration
    })
  }
}

export default Setting
